import React from 'react';

interface Props {
	address1: string,
	address2: string,
	address3: string,
	city: string,
	state: string,
	country: string,
	postalCode: string,
}

export function AddressDisplay(props: Props) {

	const renderLine = (text: string) => {

		return (

			text ?
				<p>{text}</p>
				: null
		);
	};

	const cityStatePostal = [props.city, props.state, props.postalCode].filter(a => a);

	return (

		<>
			{renderLine(props?.address1)}
			{renderLine(props?.address2)}
			{renderLine(props?.address3)}
			{renderLine(cityStatePostal.join(', '))}
			{renderLine(props?.country)}
		</>
	);
}
